import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './utilities/ScrollToTop';

// Layout
import MainLayout from './layouts/MainLayout';

// Pages & Components 
import UfficientLandingHero from './components/UfficientLandingHero';
import CredibilityTicker from './components/TrustStrip';
import ShowcaseWheel from './components/ShowcaseWheel';
import UnifiedPlatformShowcase from './components/UnifiedPlatformShowcase';
import SecurityTrustShowcase from './components/SecurityTrustShowcase';
import UseCasesShowcase from './components/UseCasesShowcase';
import ComparisonTable from './components/ComparisonTable';
import SecurityShowcase from './components/SecurityShowcase';

// Page components
import FeaturesPage from './components/FeaturesPage';
import FeatureDetailPage from './components/FeatureDetailPage';
import SolutionsPage from './components/SolutionsPage';
import ComingSoonPage from './components/ComingSoonPage';
import ContactPage from './components/ContactPage';
import UpdatesPage from './components/UpdatesPage';
import PricingPage from './components/PricingPage';
import FAQPage from './components/FAQPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPages';
import TermsOfServicePage from './components/TermsOfServicePage';
import CookiePolicyPage from './components/CookiePolicyPage';
import EULAPage from './components/EULAPage';
import AboutPage from './components/About';
import TrustPage from './components/TrustPage';
import WhyUfficientPage from './components/WhyUfficientPage';
import CoreHubShowcase from './components/CoreHubShowcase';
import HowItWorks from './components/HowItWorks';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <MainLayout>
        <Routes>
          <Route path="/" element={
            <>
              <UfficientLandingHero />
              <CredibilityTicker />
              <CoreHubShowcase />
              <ShowcaseWheel />
              <UnifiedPlatformShowcase />
              <SecurityTrustShowcase />
              <UseCasesShowcase />
              <ComparisonTable />
            </>
          } />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/features/:slug" element={<FeatureDetailPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/resources" element={<ComingSoonPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/demo" element={<ComingSoonPage />} />
          <Route path="/docs" element={<ComingSoonPage />} />
          <Route path="/tutorials" element={<ComingSoonPage />} />
          <Route path="/case-studies" element={<ComingSoonPage />} />
          <Route path="/updates" element={<UpdatesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/careers" element={<ComingSoonPage />} />
          <Route path="/partners" element={<ComingSoonPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/eula" element={<EULAPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/faqs" element={<FAQPage />} />
          <Route path="/trust" element={<TrustPage />} />
          <Route path="/why-ufficient" element={<WhyUfficientPage />} />
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App;